import {
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { DailyActivityAPI } from '@pages/daily/activity/activity';
import { ReportService } from '@pages/report/report.service';
import { ApiService } from './api.service';
import { ApiAuthService } from './auth/auth.service';
import { ApiChatService } from './chat/chat.service';
import { ApiChatWebsocketService } from './chat/chat.ws.service';
import { ApiHealthTrackerModule } from './health-tracker/health-tracker.module';
import { ApiReportService } from './report/report.service';
import { ReportQuestionnaireAPIService } from './report-questionnaire/report-questionnaire.service';
import { SubscriptionService } from './subscription/subscription.service';
import { UserAPIService } from './user/user.service';
import { WearablesIntegrationService } from './wearables-integration/wearables-integration';

/**
 * API Module.
 *
 * @exports
 * @class ApiModule
 */
@NgModule({
  imports: [ApiHealthTrackerModule],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    ApiService,
    ApiAuthService,
    ApiReportService,
    ReportQuestionnaireAPIService,
    UserAPIService,
    ApiChatService,
    ApiChatWebsocketService,
    ReportService,
    WearablesIntegrationService,
    DailyActivityAPI,
    SubscriptionService
  ]
})
export class ApiModule {}
